export default "__VITE_ASSET__b28d4710__"